import React from 'react';
import { GRID_SIZE } from '../Map/Grid';

export interface Patterns {
    cone: (size: number) => JSX.Element,
    sphere: (size: number) => JSX.Element,
    cylinder: (size: number) => JSX.Element,
    cube: (size: number) => JSX.Element,
    line: (size: number) => JSX.Element,
    permanentCube: (size: number) => JSX.Element,
    permanentCircle: (size: number) => JSX.Element,
}

const patterns: Patterns = {
    cone: (size) => (
        <polygon
            points={
                `0, 0`
                + ` ${size / 5 * GRID_SIZE}, -${size / 10 * GRID_SIZE}`
                + ` ${size / 5 * GRID_SIZE}, ${size / 10 * GRID_SIZE}`
            }
            className='fill-rose-600 opacity-50'
        />
    ),
    sphere: (size) => (
        <circle cx={0} cy={0} r={size / 5 * GRID_SIZE} className='fill-rose-600 opacity-50' />
    ),
    cylinder: (size) => (
        <circle cx={0} cy={0} r={size / 5 * GRID_SIZE} className='fill-rose-600 opacity-50' />
    ),
    cube: (size) => (
        <polygon
            points={
                `0, -${size/10 * GRID_SIZE}`
                + ` ${size / 5 * GRID_SIZE}, -${size/10 * GRID_SIZE}`
                + ` ${size / 5 * GRID_SIZE}, ${size / 10 * GRID_SIZE}`
                + ` 0, ${size / 10 * GRID_SIZE}`
            }
            className='fill-rose-600 opacity-50'
        />
    ),
    line: (size) => (
        <polygon
            points={
                `0, ${-GRID_SIZE / 2}`
                + ` ${size / 5 * GRID_SIZE}, ${-GRID_SIZE / 2}`
                + ` ${size / 5 * GRID_SIZE}, ${GRID_SIZE / 2}`
                + ` 0, ${GRID_SIZE / 2}`
            }
            className='fill-rose-600 opacity-50'
        />
    ),
    permanentCube: (size) => (
        <polygon
            points={
                '0, 0'
                + ` ${size / 5 * GRID_SIZE}, 0`
                + ` ${size / 5 * GRID_SIZE}, ${size / 5 * GRID_SIZE}`
                + ` 0, ${size / 5 * GRID_SIZE}`
            }
            className='fill-rose-600 opacity-50'
        />
    ),
    permanentCircle: (size) => (
        <circle
            cx={(size / 5) * GRID_SIZE}
            cy={(size / 5) * GRID_SIZE}
            r={size / 5 * GRID_SIZE}
            className='fill-rose-600 opacity-50'
        />
    ),
};

export default patterns;
